//Formatter for conditional non summary datagrid cells - distinct behavior that can be extended if needed
export const formatCurrencyConditional = (value) => {
    if (value == null) return undefined;

    const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    if (Number.isInteger(rounded)) {
        // Whole number → no decimals
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(rounded);
    } else {
        // Has decimals → always 2 digits
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(rounded);
    }
};

//Formatter for conditional summary datagrid cells - distinct behavior that can be extended if needed
export const conditionalTwoDigitSummaryCurrency = (data) => {
    const value = Math.round((data.value + Number.EPSILON) * 100) / 100;
    if (Number.isInteger(value)) {
        // Whole number → no decimals
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    } else {
        // Has decimals → always 2 digits
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
};
